import React from "react";
import { useTranslation } from "react-i18next";
import { Box, BoxProps, Step, StepLabel, Stepper } from "@material-ui/core";
import { OnboardingSideMenuProps } from "../../../../../types/onboarding";
import { CircleIconStatus } from "../../../../../types/circle-icon";
import CircleIcon from "../CircleIcon/CircleIcon";
import "./OnboardingSideMenu.component.scoped.scss";

const OnboardingSideMenu: React.FC<OnboardingSideMenuProps> = ({
  menuTabs,
  selectedTab,
}: any) => {
  const { t } = useTranslation();
  const MenuWrapper: BoxProps = {
    bgcolor: "var(--secondary-color)",
    height: "100vh",
  };

  const getTabStatus = (value: number): CircleIconStatus => {
    if (selectedTab > value) {
      return CircleIconStatus.COMPLETED;
    } else if (selectedTab === value) {
      return CircleIconStatus.ACTIVE;
    } else {
      return CircleIconStatus.NONE;
    }
  };

  return (
    <Box {...MenuWrapper} p={5}>
      <div className="d-flex flex-wrap align-items-center ml-2 compliance">
        <img
          src="/icons/logos/pAIper.png"
          alt="compliance-logo"
          className="w-100"
        />
      </div>
      <Box>
        <Stepper activeStep={selectedTab} orientation="vertical">
          {menuTabs.map((tab: any, index: number) => {
            return (
              <Step key={tab.label}>
                <StepLabel
                  icon={
                    <CircleIcon
                      status={getTabStatus(index)}
                      value={index + 1}
                    />
                  }
                >
                  <div
                    className={
                      getTabStatus(index) === CircleIconStatus.ACTIVE
                        ? "active-label"
                        : "inactive-label"
                    }
                  >
                    {t(tab.label)}
                  </div>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>
    </Box>
  );
};

export default OnboardingSideMenu;
